import { SearchOutlined } from '@ant-design/icons'
import { Input, message, Pagination } from 'antd'
import Select from 'react-select'
import Moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal } from 'react-bootstrap-v5'
import { shallowEqual, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { RootState } from '../../setup/redux/RootReducer'
import httpService from '../../setup/http/httpServices'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import { IUserModel } from '../modules/auth/models/UserModel'
import '../masters/basic.css'
import clsx from 'clsx'
export function WebsiteListingTable(props: any) {
  const user: IUserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IUserModel

  const [sort1, setSort1] = useState('rotate-90 ms-2')
  const [asc, setAsc] = useState('firstName')
  const [sort2, setSort2] = useState('rotate-90 ms-2')
  const [sort4, setSort4] = useState('rotate-90 ms-2')
  const [show, setShow] = useState(false)
  const [status, setStatus] = useState(true)
  const history: any = useHistory()
  const [websites, setWebsites] = useState([])



  const [deleteId, setDeleteId] = useState('')

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)



  const websiteTypeSelectOptions = useMemo(() => [
    {
      label: "Source from existing websites",
      value: "EXISTING"
    },
    {
      label: "Source from non-existing website",
      value: "NON-EXISTING"
    },
    {
      label: "Figma Components",
      value: "FIGMA"
    },
  ], [])

  const [componentType, setComponentType] = useState({
    label: "Source from existing websites",
    value: "EXISTING"
  })

  // console.log(websiteTypeSelectOptions)

  const [listParams, setListParams] = useState({
    limit: 20,
    page: 1,
    total: 0,
    search: '',
  })
  const pageType = props.type
  const [totalCount, setTotalCount] = useState(0)

  const page = listParams.search ? 1 : listParams.page;

  //function to fetch data
  const getData = async () => {
    setStatus(true)
    setWebsites([])
    httpService.getData(
      '/associated-component/?limit=' +
      listParams.limit +
      '&componentStatus=' +
      componentType.value +
      '&page=' +
      page +
      '&search=' +
      listParams.search +
      '&sort=' +
      asc,
      (res) => {
        setStatus(false)
        // console.log(res)
        // console.log(res.data)
        setWebsites(res.data.components)
        setTotalCount(res.data.getCount)
      },
      (err) => {
        console.log(err)
        setStatus(false)
      }
    )
  }

  const handleDelete = async () => {
    if (!deleteId) return;
    await httpService.deleteData(
      "/associated-component/" + deleteId,
      (res) => {
        message.success("Section deleted successfully")
        handleClose()
        getData()
      },
      (err) => {
        message.error(err?.response?.data?.message || "Something went wrong")
      }
    )
  }


  useEffect(() => {
    getData()
  }, [asc, listParams, componentType])


  const Sorting1 = () => {
    if (sort1 == 'rotate-90 ms-2') {
      setSort1('rotate-270 ms-2')
    } else {
      setSort1('rotate-90 ms-2')
    }
    if (sort1 == 'rotate-90 ms-2') {
      setSort4('rotate-90 ms-2')
      setSort2('rotate-90 ms-2')
      setAsc('-firstName')
    } else {
      setSort4('rotate-90 ms-2')
      setSort2('rotate-90 ms-2')
      setAsc('firstName')
    }
  }
  let tableStyle = {
    height:
      totalCount > 8
        ? 'auto'
        : totalCount === 4
          ? (totalCount * 92).toString() + 'px'
          : totalCount > 6 || totalCount === 0
            ? (totalCount * 79).toString() + 'px'
            : (totalCount * 86).toString() + 'px',
    minHeight: '650px',
  }

  return (
    <>
      <div style={{ minHeight: '150px' }}>
        <div className='TableHeader d-flex justify-content-between'>
          <div className='mt-3 min-w-150px'>
            <h3 style={{ cursor: 'default' }}>Sections Listings</h3>
            <p style={{ cursor: 'default' }} className='text-gray-500 fs-7'>
              {totalCount} Active Sections
            </p>
          </div>
          <div className='d-flex align-items-center' style={{ height: '41px', gap: '8px' }}>
            <link
              href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
              rel='stylesheet'
            />
            <Select
              className={clsx(
                'rounded-4 bg-gray-100 p-0 border-0 form-select form-select-solid h-100 min-w-300px'
              )}
              options={websiteTypeSelectOptions}
              onChange={e => {
                console.log(e);
                setComponentType(e)
              }}
              value={componentType}
            />
            <Input
              placeholder='Search'
              style={{ borderRadius: '6px' }}
              className='form-control-solid rounded-4 bg-gray-100 shadow-none h-100 min-w-300px'
              onChange={(e: any) => {
                const params = { ...listParams }
                params.search = e.target.value
                setListParams({ ...params })
                // getAllBrands()
              }}
              prefix={
                <>
                  <SearchOutlined />
                </>
              }
            />

            <button
              onClick={() => {
                history.push({
                  pathname: componentType.value == "NON-EXISTING" ? "/website/add-components-non" : componentType.value == "EXISTING" ? "/website/add-components-new" : "/website/add-components-figma"
                })
              }}
              className="btn btn-dark min-w-175px">
              + Add Section
            </button>
          </div>
        </div>
        <div className='card-body mt-0 p-0 d-flex flex-column justify-content-between'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            {
              componentType.value != "FIGMA"
                ?
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='bg-primary bg-opacity-5 min-w-190px'>
                        <span className='d-flex ms-8'>
                          Website URL
                          <a
                            className={sort1}
                            onClick={() => {
                              Sorting1()
                            }}
                          >
                            <KTSVG
                              className='svg-icon svg-icon-sm svg-icon-gray-700 flex h-20px pointer'
                              path={toAbsoluteUrl('/media/icons/Custom/SideArrow.svg')}
                            />
                          </a>
                        </span>
                      </th>
                      <th className='bg-primary bg-opacity-5 min-w-110px'>
                        <span className='d-flex'>Section Category</span>
                      </th>
                      <th className='bg-primary bg-opacity-5 min-w-110px'>
                        <span className='d-flex'>Views</span>
                      </th>
                      {/* <th className='bg-primary bg-opacity-5 min-w-120px'>
                    <span className='d-flex'>Pages</span>
                  </th> */}
                      <th className='bg-primary bg-opacity-5 min-w-110px'>
                        <span className='d-flex'>Sections Added</span>
                      </th>
                      {/* {(user.permissions.masters[1] || user.permissions.admin) && ( */}
                      <th className='bg-primary bg-opacity-5 min-w-100px d-flex justify-content-end'>
                        Actions
                      </th>
                      {/* )} */}
                    </tr>
                  </thead>
                  {/* end::Table head */}
                  {/* begin::Table body */}

                  <tbody>
                    {websites?.length > 0 &&
                      websites?.map((data: any, index: number) => (
                        <tr key={index}>
                          <td>
                            <div className='d-flex align-items-center ms-8'>
                              <div className='d-flex justify-content-start flex-column'>
                                <span className='text-dark fw-bolder text-hover-primary fs-6'>
                                  {data.websiteUrl}
                                </span>
                              </div>
                            </div>
                          </td>
                          {/* <td>{data.AssociatedPages.length}</td> */}
                          <td>{data?.componentCategories?.map((i, key) => (
                            <span className='badge badge-light' style={{ marginRight: '4px' }}>
                              {i}
                            </span>
                          ))}</td>
                          <td>{data.views}</td>
                          <td>{data.componentsAdded}</td>
                          {/* {pageType === 'Agency' && (
                        <td className='fw-bolder'>{data.isActive ? 'Active' : 'Inactive'}</td>
                      )} */}
                          {/* {(user.permissions.masters[1] || user.permissions.admin) && ( */}
                          <td className='d-flex justify-content-end'>
                            <div className='d-flex justify-content-start flex-shrink-0'>
                              <span
                                className='svg-icon flex svg-icon-dark bg-primary bg-opacity-5 w-30px h-30px rounded me-2 pointer'
                                onClick={() => {
                                  console.log(data)
                                  history.push({
                                    pathname: componentType.value == "EXISTING" ? "/website/add-components-new" : '/website/add-components-non',
                                    state: { data: data, edit: true },
                                  })
                                }}
                              >
                                <KTSVG
                                  className='svg-icon-3'
                                  path={toAbsoluteUrl('/media/icons/Custom/Pen.svg')}
                                />
                              </span>
                            </div>
                          </td>
                          {/* )} */}
                        </tr>
                      ))}
                    {websites?.length === 0 && !status && (
                      <tr>
                        <td colSpan={7}>
                          <div className='m-20'>
                            <div className='flex'>
                              <img
                                className='ms-20'
                                src={toAbsoluteUrl('/media/logos/TableVector.png')}
                              ></img>
                            </div>
                            <div className='flex'>
                              <div>
                                <h2 className='mb-0 m24 flex'>No {pageType} Listed</h2>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {websites?.length === 0 && status && (
                      <tr>
                        <td colSpan={7}>
                          <div className='m-20'>
                            <div className='flex'>
                              <span className='svg-icon svg-icon-5x flex svg-icon-primary me-3 ms-8'>
                                <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Loading.svg')} />
                              </span>
                            </div>
                            <div className='flex'>
                              <div>
                                <h5 className='mb-0 mt-3 flex'>Fetching Data</h5>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>


                  {/* end::Table body */}
                </table>
                :
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='bg-primary bg-opacity-5 min-w-190px'>
                        <span className='d-flex ms-8'>
                          Components Category
                          <a
                            className={sort1}
                            onClick={() => {
                              Sorting1()
                            }}
                          >
                            <KTSVG
                              className='svg-icon svg-icon-sm svg-icon-gray-700 flex h-20px pointer'
                              path={toAbsoluteUrl('/media/icons/Custom/SideArrow.svg')}
                            />
                          </a>
                        </span>
                      </th>
                      {/* <th className='bg-primary bg-opacity-5 min-w-120px'>
                  <span className='d-flex'>Pages</span>
                </th> */}
                      <th className='bg-primary bg-opacity-5 min-w-110px'>
                        <span className='d-flex'>Views</span>
                      </th>
                      {/* {(user.permissions.masters[1] || user.permissions.admin) && ( */}
                      <th className='bg-primary bg-opacity-5 min-w-100px d-flex justify-content-end'>
                        Actions
                      </th>
                      {/* )} */}
                    </tr>
                  </thead>
                  <tbody>
                    {websites?.length > 0 &&
                      websites.map((data: any, index: number) => (
                        <tr key={index}>
                          <td>
                            <div className='d-flex align-items-center ms-8'>
                              <div className='d-flex justify-content-start flex-column'>
                                <span className='text-dark fw-bolder text-hover-primary fs-6'>
                                  {data.componentCategoryName}
                                </span>
                              </div>
                            </div>
                          </td>
                          {/* <td>{data.AssociatedPages.length}</td> */}
                          <td>{data.componentViewCount}</td>
                          {/* {pageType === 'Agency' && (
                        <td className='fw-bolder'>{data.isActive ? 'Active' : 'Inactive'}</td>
                      )} */}
                          {/* {(user.permissions.masters[1] || user.permissions.admin) && ( */}
                          <td className='d-flex justify-content-end'>
                            <div className='d-flex justify-content-start flex-shrink-0'>
                              <span
                                className='svg-icon flex svg-icon-dark bg-primary bg-opacity-5 w-30px h-30px rounded me-2 pointer'
                                onClick={() => {
                                  console.log(data)
                                  history.push({
                                    pathname: '/website/add-components-figma',
                                    state: { data: data, edit: true },
                                  })
                                }}
                              >
                                <KTSVG
                                  className='svg-icon-3'
                                  path={toAbsoluteUrl('/media/icons/Custom/Pen.svg')}
                                />
                              </span>
                              <span
                                className='svg-icon flex svg-icon-danger bg-danger bg-opacity-5 w-30px h-30px rounded me-2 pointer'
                                onClick={() => {
                                  console.log(data)
                                  setDeleteId(data._id)
                                  setShow(true)
                                }}
                              >
                                <KTSVG
                                  className='svg-icon-3'
                                  path={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                                />
                              </span>
                              <Modal
                                show={show}
                                onHide={handleClose}
                                aria-labelledby='contained-modal-title-vcenter'
                                centered
                              >
                                <Modal.Header>
                                  <Modal.Title>Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>Are you sure you wanna delete?</Modal.Body>
                                <Modal.Footer>
                                  <button
                                    className='btn fw-bolder btn-gray-200 fs-6 dialogButton'
                                    onClick={() => {
                                      setShow(false)
                                      setDeleteId('')
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className='btn btn-primary fs-6 dialogButton ms-2'
                                    onClick={() => handleDelete()}
                                  >
                                    Delete
                                  </button>
                                </Modal.Footer>
                              </Modal>
                            </div>
                          </td>
                          {/* )} */}
                        </tr>
                      ))}
                    {websites?.length === 0 && !status && (
                      <tr>
                        <td colSpan={7}>
                          <div className='m-20'>
                            <div className='flex'>
                              <img
                                className='ms-20'
                                src={toAbsoluteUrl('/media/logos/TableVector.png')}
                              ></img>
                            </div>
                            <div className='flex'>
                              <div>
                                <h2 className='mb-0 m24 flex'>No {pageType} Listed</h2>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {websites?.length === 0 && status && (
                      <tr>
                        <td colSpan={7}>
                          <div className='m-20'>
                            <div className='flex'>
                              <span className='svg-icon svg-icon-5x flex svg-icon-primary me-3 ms-8'>
                                <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Loading.svg')} />
                              </span>
                            </div>
                            <div className='flex'>
                              <div>
                                <h5 className='mb-0 mt-3 flex'>Fetching Data</h5>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

            }

            {/* end::Table */}
          </div>
          {totalCount > 8 && (
            <div className='d-flex ms-5 me-10 justify-content-between align-items-end flex-wrap mb-10'>
              <span className='text-muted pb-2'>
                Page {listParams.page} of{' '}
                {Math.floor(totalCount % listParams.limit) === 0
                  ? Math.floor(totalCount / listParams.limit)
                  : Math.floor(totalCount / listParams.limit) + 1}
              </span>
              <div className='d-flex flex-wrap '>
                <Pagination
                  className=''
                  pageSize={listParams.limit}
                  defaultCurrent={listParams.page}
                  total={totalCount}
                  onChange={(e) => setListParams({ ...listParams, ...{ page: e } })}
                />
              </div>
            </div>
          )}
          {/* end::Table container */}
        </div>
      </div>
    </>
  )
  //   return (
  //     <>
  //       <div className='TableHeader'>
  //         <div className='mt-3 min-w-150px'>
  //           <h3 style={{cursor: 'default'}}>{pageType}</h3>
  //           <p style={{cursor: 'default'}} className='text-gray-500 fs-7'>
  //             {totalCount} active {pageType}
  //           </p>
  //         </div>
  //         <div className='TableHeaderSearch d-flex align-items-center'>
  //           <link
  //             href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
  //             rel='stylesheet'
  //           />
  //           <Input
  //             placeholder='Search'
  //             style={{width: '250px', height: '40px'}}
  //             className='form-control-solid rounded-4 bg-gray-100'
  //             prefix={
  //               <>
  //                 <SearchOutlined />
  //               </>
  //             }
  //           />
  //         </div>
  //         {/* <div className='flex'>
  //           <span
  //             style={{width: '31px', height: '31px'}}
  //             className='svg-icon flex svg-icon-primary bg-primary bg-opacity-5 me-3 rounded pointer'
  //           >
  //             <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Filter.svg')} />
  //           </span>
  //         </div>
  //         <div className='flex'>
  //           <span
  //             style={{width: '31px', height: '31px'}}
  //             className='svg-icon rounded flex svg-icon-primary bg-primary bg-opacity-5 me-3 pointer'
  //           >
  //             <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Export.svg')} />
  //           </span>
  //         </div> */}
  //         <div className='flex'>
  //           <Link
  //             to={{
  //               pathname: '/companyDetails',
  //               state: {
  //                 companyDetails: history.location.state?.companyDetails,
  //                 agencyDetails: history.location.state?.agencyDetails,
  //                 type: pageType,
  //               },
  //             }}
  //           >
  //             <button
  //               style={{width: '92px', height: '34px', fontSize: '12px'}}
  //               className='btn btn-primary d-flex flex me-2'
  //             >
  //               + Add
  //             </button>
  //           </Link>
  //         </div>
  //       </div>
  //       <div className='card-body mt-0 p-0'>
  //         {/* begin::Table container */}
  //         <div className='table-responsive'>
  //           {/* begin::Table */}
  //           <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
  //             {/* begin::Table head */}
  //             <thead>
  //               <tr className='fw-bolder text-muted'>
  //                 <th className='bg-primary bg-opacity-5  w-25px'>
  //                   <div className='form-check ms-5 form-check-sm form-check-custom form-check-solid'>
  //                     <input
  //                       className='form-check-input'
  //                       type='checkbox'
  //                       value='1'
  //                       data-kt-check='true'
  //                       data-kt-check-target='.widget-9-check'
  //                     />
  //                   </div>
  //                 </th>
  //                 <th className='bg-primary bg-opacity-5 min-w-190px'>{pageType} Name</th>
  //                 <th className='bg-primary bg-opacity-5 min-w-180px'>
  //                   Email
  //                 </th>
  //                 <th className='bg-primary bg-opacity-5 min-w-120px'>Role</th>
  //                 <th className='bg-primary bg-opacity-5 min-w-110px'>Linked Using</th>
  //                 <th className='bg-primary bg-opacity-5 min-w-100px'>Actions</th>
  //               </tr>
  //             </thead>
  //           </table>
  //           {/* end::Table */}
  //         </div>
  //         {/* end::Table container */}
  //       </div>
  //     </>
  //   )
  // }
}
